import {Component, ViewChild} from '@angular/core';
import {
  AlertController,
  Content,
  IonicPage,
  Keyboard,
  LoadingController,
  NavController,
  NavParams
} from 'ionic-angular';
import {LoginItem} from "../login/login-item";
import {IntroWelcomePage} from "../intro-welcome/intro-welcome";
import {PasswordForgottenPage} from "../password-forgotten/password-forgotten";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {StatusBar} from "@ionic-native/status-bar";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {InitHelloPage} from "../init-hello/init-hello";
import {Subscription} from "rxjs";
import {LoginPage} from "../login/login";

/**
 * Generated class for the PasswordForgottenUpdatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-password-forgotten-update',
  templateUrl: 'password-forgotten-update.html',
})
export class PasswordForgottenUpdatePage {
  @ViewChild(Content) public content: Content;

  item: LoginItem;
  registerPage: any = LoginPage;

  errorVisible: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public auth: ApiAuthProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController, private keyboard: Keyboard,  public statusBar: StatusBar, public contentTranslation: ContentTranslationProvider) {
    this.item = new LoginItem();
  }

  hideError() {
    this.errorVisible = false;
  }

  login() {
    if (!this.item.password) {
      this.errorVisible = true;
      return ;
    }
    let loading = this.loadingCtrl.create({
      content: this.contentTranslation.translateContent('Please wait...')
    });

    loading.present();

    let me = this;

    const showFailedAlert = () => {
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('New Password update failed title'),
        subTitle: this.contentTranslation.translateContent('New Password update failed text'),
        buttons: [
          {
            text: 'OK',
            handler: () => {
              this.navCtrl.pop();
            }
          },
          {
            text: '×',
            cssClass: 'close-button',
            handler: () => {
              this.navCtrl.pop();
            }
          }

        ],
        cssClass: 'ip-alert ip-with-close'
      });
      alert.present();
    }

    this.auth.passwordForgottenUpdate(this.navParams.data.token, this.item.password).then((res) => {
      loading.dismiss();

      if(!res) {
        showFailedAlert();
        return ;
      }

      this.navCtrl.pop();
      this.navCtrl.push(LoginPage);
    }, (err) => {
      loading.dismiss();
      showFailedAlert();
    })


  }

  keyboardDidShowCallback: Subscription;
  keyboardShowCallback: Subscription;
  keyboardHideCallback: Subscription;
  ionViewDidLoad() {
    var me = this;

    this.keyboardShowCallback = this.keyboard.willShow.subscribe(function() {
    }, () => {}, () => {
      me.content.scrollToBottom();
    });
    this.keyboardDidShowCallback = this.keyboard.didShow.subscribe(function() {
      setTimeout(() => {
        me.content.scrollToBottom();
      }, 50);
    });


    this.keyboardHideCallback = this.keyboard.willHide.subscribe(function() {
    });
  }

  ionViewDidLeave() {
    this.keyboardShowCallback.unsubscribe();
    this.keyboardHideCallback.unsubscribe();
    this.keyboardDidShowCallback.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/pages/password-forgotten-update/password-forgotten-update.ts